import { render } from "./Drawer.vue?vue&type=template&id=0daa2a8c&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"

import "./Drawer.vue?vue&type=style&index=0&id=0daa2a8c&lang=scss&scoped=true"
import "./Drawer.vue?vue&type=style&index=1&id=0daa2a8c&lang=scss"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daa2a8c"]])

export default __exports__